<ng-container [formGroup]="form">

	<mat-form-field class="form-control form-field dark-color pr-3"
					[class.empty]="!form.value[controlName]?.length"
					[class.error]="hasError()"
					[class.full-width]="fullWidth" appearance="fill"
					[class.fix-multiselect-padding]="!label"
	>
		<mat-label *ngIf="label">{{ label }}</mat-label>
		<mat-chip-list #chipList [attr.aria-label]="label || 'Selection'">
			<mat-chip
				*ngFor="let item of form.value[controlName] | transformObject: InputUtils.conditionalSort:order:optionValueKey"
				(removed)="remove(item)"
			>
				{{item?.[optionLabelKey] || item?.label || item?.name || item?.[optionValueKey] || item?.id || item}}
				<button matChipRemove>
					<mat-icon>cancel</mat-icon>
				</button>
			</mat-chip>

			<input
				*ngIf="!readonly"
				[placeholder]="placeholder || InputPlaceholder"
				#itemInput
				[formControl]="itemCtrl"
				[matAutocomplete]="auto"
				[matChipInputFor]="chipList"
				[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
				(matChipInputTokenEnd)="add($event)"
			>
		</mat-chip-list>
		<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
			<mat-option *ngFor="let item of filteredItems$ | async" [value]="item" [class.multiline]="sublineKey && item[sublineKey]">
				<div>{{item?.[optionLabelKey] || item?.label || item?.name || item?.[optionValueKey] || item?.id || item}}</div>
				<div *ngIf="sublineKey && item[sublineKey]" class="subline">{{item[sublineKey]}}</div>
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>

	<div *ngIf="hint" class="input-hint">{{ hint }}</div>

</ng-container>
